import { HTTP } from 'providers'

export class IndustryCertificateService extends HTTP {
  private endpoint = '/industry-certificates'

  public fetchAll({
    params = {},
    companyId
  }: {
    params?: Record<string, any>
    companyId: string
  }) {
    return this.get({
      endpoint: this.endpoint,
      params: { ...params, companyId }
    })
  }

  public fetchOne(id) {
    return this.get({
      endpoint: `${this.endpoint}/${id}`
    })
  }
}
